import React, { useEffect, useState } from 'react';

export default function Footer() {
  // current year
  let year = new Date().getFullYear();

  // year state
  const [currentYear, setCurrentYear] = useState();

  useEffect(() => {
    setCurrentYear(year);
  }, [year]);

  return (
    <footer id="footer">
      <div className="container">
        <div className="copyright">
          {' '}
          tousifprovat <i className="far fa-copyright"></i> {currentYear}
        </div>
        <ul className="social-links">
          <li>
            <a
              href="https://github.com/TousifProvat"
              aria-label="Github"
              rel="noreferrer"
              target="_blank"
            >
              <i className="fab fa-github-square fa-2x"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/tousif-ahmed-66a18621a/"
              aria-label="Linkedin"
              rel="noreferrer"
              target="_blank"
            >
              <i className="fab fa-linkedin fa-2x"></i>
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
}
